var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVl1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250.101,
    height: 242.307,
    viewBox: "0 0 250.101 242.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M236.5,292.063l-11.176,13.584H155.336V288.56a13.648,13.648,0,0,1-21.017-2.335L108.285,245.96l13.343-12.17,17.323,21.769,9.571-16.632A26.058,26.058,0,0,1,171.1,225.87h7.718a34.417,34.417,0,0,0,3.357,6.416,13.4,13.4,0,0,0,22.19.769,40.96,40.96,0,0,0,4.176-7.185h.814a26.057,26.057,0,0,1,24.811,18.1l7.219,22.515A27.2,27.2,0,0,1,236.5,292.063Z",
    transform: "translate(-108.285 -225.87)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1924",
    "data-name": "Group 1924",
    transform: "translate(-143.949 -1045.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M217.892,465.153H14.59c-.1,0-.174-.105-.174-.235s.078-.234.174-.234h203.3c.1,0,.174.105.174.234S217.988,465.153,217.892,465.153Z",
    transform: "translate(162.533 814.343)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003",
    transform: "translate(143.949 1046.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_923",
    "data-name": "Group 923",
    transform: "translate(0 9.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907",
    transform: "translate(230.969 125.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M-480.693,339.445l-2.825-2.918,3.94-.988Z",
    transform: "translate(483.518 -335.539)",
    fill: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908",
    transform: "translate(14.941 129.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M-150.529,345.027l2.825,2.918-3.94.988Z",
    transform: "translate(151.643 -345.027)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909",
    transform: "translate(60.751 95.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M-212.955,271.7l-3.109,2.614-.71-4Z",
    transform: "translate(216.773 -270.31)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910",
    transform: "translate(189.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M-425.2,60.06l3.986.783-2.671,3.06Z",
    transform: "translate(425.203 -60.06)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911",
    transform: "translate(228.233 19.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M-473.989,104.874a1.175,1.175,0,0,1,1.174-1.174,1.174,1.174,0,0,1,1.174,1.174,1.174,1.174,0,0,1-1.174,1.174A1.174,1.174,0,0,1-473.989,104.874Z",
    transform: "translate(473.989 -103.7)",
    fill: "#eee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912",
    transform: "translate(0 79.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M-115.241,236.9a1.175,1.175,0,0,1,1.174-1.174,1.175,1.175,0,0,1,1.174,1.174,1.175,1.175,0,0,1-1.174,1.174A1.175,1.175,0,0,1-115.241,236.9Z",
    transform: "translate(115.241 -235.727)",
    fill: "#eee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913",
    transform: "translate(15.049 12.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M-148.376,88.926a1.175,1.175,0,0,1,1.174-1.174,1.174,1.174,0,0,1,1.174,1.174A1.174,1.174,0,0,1-147.2,90.1,1.175,1.175,0,0,1-148.376,88.926Z",
    transform: "translate(148.376 -87.752)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914",
    transform: "translate(235.541 71.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M-490.082,218.525a1.175,1.175,0,0,1,1.174-1.174,1.174,1.174,0,0,1,1.174,1.174,1.174,1.174,0,0,1-1.174,1.174A1.174,1.174,0,0,1-490.082,218.525Z",
    transform: "translate(490.082 -217.351)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915",
    transform: "translate(11.634 39.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M-138.788,147.009a.7.7,0,0,1,.7-.7.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7A.7.7,0,0,1-138.788,147.009Z",
    transform: "translate(138.788 -146.305)",
    fill: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916",
    transform: "translate(19.39 76.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M-155.867,228.154a.7.7,0,0,1,.7-.7.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7A.7.7,0,0,1-155.867,228.154Z",
    transform: "translate(155.867 -227.45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917",
    transform: "translate(107.089 2.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M-287.051,65.45a.7.7,0,0,1,.7-.7.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7A.7.7,0,0,1-287.051,65.45Z",
    transform: "translate(287.051 -64.745)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918",
    transform: "translate(121.313 58.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M-310.146,190.24a.7.7,0,0,1,.7-.7.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7A.7.7,0,0,1-310.146,190.24Z",
    transform: "translate(310.146 -189.536)",
    fill: "#324498"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919",
    transform: "translate(248.692 66.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M-516.971,208.238a.7.7,0,0,1,.7-.7.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7A.7.7,0,0,1-516.971,208.238Z",
    transform: "translate(516.971 -207.533)",
    fill: "#324498"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_920",
    "data-name": "Group 920",
    transform: "translate(3.279 33.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M-120.392,134.26a.7.7,0,0,1,.7-.7.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7A.7.7,0,0,1-120.392,134.26Z",
    transform: "translate(120.392 -133.555)",
    fill: "#eee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_921",
    "data-name": "Group 921",
    transform: "translate(245.954 50.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M-510.94,173.054a.7.7,0,0,1,.7-.7.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7A.7.7,0,0,1-510.94,173.054Z",
    transform: "translate(510.94 -172.35)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_922",
    "data-name": "Group 922",
    transform: "translate(128.749 49.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M-322.221,169.4a.7.7,0,0,1,.7-.7.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7A.7.7,0,0,1-322.221,169.4Z",
    transform: "translate(322.221 -168.692)",
    fill: "#270504"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_956",
    "data-name": "Group 956",
    transform: "translate(2.511 24.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927",
    transform: "translate(31.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_924",
    "data-name": "Group 924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M-191.361,97.357a4.434,4.434,0,0,1,4.748-4.422,4.45,4.45,0,0,1,4.112,4.177,4.419,4.419,0,0,1-.7,2.654,9.953,9.953,0,0,0-1.359,3.068l-.123.505h-4.48l-.106-.437a10.419,10.419,0,0,0-1.389-3.157A4.408,4.408,0,0,1-191.361,97.357Z",
    transform: "translate(191.361 -92.924)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_925",
    "data-name": "Group 925",
    transform: "translate(1.585 10.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M-187.372,116.725h.11v-.35h-.11a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4.7a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-.109v.35h.109a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-4.7a.5.5,0,0,1-.5-.5A.5.5,0,0,1-187.372,116.725Z",
    transform: "translate(187.871 -115.378)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_926",
    "data-name": "Group 926",
    transform: "translate(3.314 4.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M-183.458,108.5h.019a.227.227,0,0,0,.208-.245c-.068-.808-.129-1.606-.189-2.4-.053-.688-.105-1.377-.162-2.072a3.005,3.005,0,0,0,1.269-.007l-.491,4.474a.227.227,0,0,0,.2.25.224.224,0,0,0,.25-.2l.527-4.8a.227.227,0,0,0-.083-.2.23.23,0,0,0-.214-.039,2.5,2.5,0,0,1-1.629,0,.227.227,0,0,0-.219.028.228.228,0,0,0-.091.2c.068.807.129,1.6.189,2.4s.122,1.6.19,2.407A.226.226,0,0,0-183.458,108.5Z",
    transform: "translate(184.064 -103.238)",
    fill: "#270504"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931",
    transform: "translate(99.182 26.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M-289.738,133.987a4.434,4.434,0,0,1,4.748-4.423,4.45,4.45,0,0,1,4.112,4.178,4.414,4.414,0,0,1-.705,2.654,9.979,9.979,0,0,0-1.359,3.068l-.122.506h-4.481l-.106-.437a10.4,10.4,0,0,0-1.389-3.157A4.409,4.409,0,0,1-289.738,133.987Z",
    transform: "translate(289.738 -129.553)",
    fill: "#eee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929",
    transform: "translate(1.585 10.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M-285.749,153.355h.109v-.35h-.109a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4.7a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-.109v.35h.109a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-4.7a.5.5,0,0,1-.5-.5A.5.5,0,0,1-285.749,153.355Z",
    transform: "translate(286.248 -152.008)",
    fill: "#324498"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930",
    transform: "translate(3.314 4.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M-281.835,145.131h.019a.226.226,0,0,0,.207-.245c-.067-.808-.128-1.606-.189-2.4-.053-.688-.105-1.377-.162-2.072a3,3,0,0,0,1.269-.007l-.491,4.473a.227.227,0,0,0,.2.251.226.226,0,0,0,.251-.2l.527-4.8a.227.227,0,0,0-.083-.2.227.227,0,0,0-.214-.039,2.5,2.5,0,0,1-1.629,0,.228.228,0,0,0-.219.028.228.228,0,0,0-.091.2c.068.807.128,1.6.189,2.4s.122,1.6.189,2.407A.227.227,0,0,0-281.835,145.131Z",
    transform: "translate(282.441 -139.868)",
    fill: "#270504"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935",
    transform: "translate(86.182 60.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M-269.473,182.187a4.434,4.434,0,0,1,4.748-4.422,4.45,4.45,0,0,1,4.112,4.178,4.415,4.415,0,0,1-.7,2.654,9.953,9.953,0,0,0-1.359,3.068l-.123.506h-4.48l-.106-.437a10.411,10.411,0,0,0-1.389-3.157A4.41,4.41,0,0,1-269.473,182.187Z",
    transform: "translate(269.473 -177.754)",
    fill: "#d4d4d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933",
    transform: "translate(1.585 10.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M-265.483,201.556h.109v-.349h-.109a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4.7a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-.109v.349h.109a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-4.7a.5.5,0,0,1-.5-.5A.5.5,0,0,1-265.483,201.556Z",
    transform: "translate(265.982 -200.209)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934",
    transform: "translate(3.314 4.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M-261.57,193.331h.019a.227.227,0,0,0,.208-.245c-.068-.807-.129-1.6-.189-2.4-.053-.688-.1-1.377-.162-2.072a3.01,3.01,0,0,0,1.268-.007l-.491,4.473a.227.227,0,0,0,.2.25.225.225,0,0,0,.251-.2l.527-4.8a.227.227,0,0,0-.083-.2.229.229,0,0,0-.214-.04,2.5,2.5,0,0,1-1.629,0,.226.226,0,0,0-.219.029.226.226,0,0,0-.091.2c.067.807.128,1.605.189,2.4s.122,1.6.19,2.406A.226.226,0,0,0-261.57,193.331Z",
    transform: "translate(262.175 -188.068)",
    fill: "#270504"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939",
    transform: "translate(12 73.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M-135.122,196.976a4.434,4.434,0,0,1,4.748-4.422,4.45,4.45,0,0,1,4.112,4.178,4.415,4.415,0,0,1-.705,2.654,9.967,9.967,0,0,0-1.359,3.068l-.123.506h-4.481l-.105-.437a10.419,10.419,0,0,0-1.389-3.157A4.41,4.41,0,0,1-135.122,196.976Z",
    transform: "translate(135.122 -192.543)",
    fill: "#eee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937",
    transform: "translate(1.585 10.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M-131.133,216.345h.109V216h-.109a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4.7a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-.109v.349h.109a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-4.7a.5.5,0,0,1-.5-.5A.5.5,0,0,1-131.133,216.345Z",
    transform: "translate(131.632 -214.998)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938",
    transform: "translate(3.314 4.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M-127.219,208.121h.019a.227.227,0,0,0,.208-.245c-.068-.807-.129-1.6-.189-2.4-.053-.689-.1-1.378-.162-2.073a3.019,3.019,0,0,0,1.269-.007l-.491,4.473a.228.228,0,0,0,.2.251.228.228,0,0,0,.251-.2l.527-4.8a.227.227,0,0,0-.083-.2.227.227,0,0,0-.214-.04,2.5,2.5,0,0,1-1.629,0,.227.227,0,0,0-.219.028.228.228,0,0,0-.091.2c.068.808.129,1.606.189,2.4s.122,1.6.189,2.405A.227.227,0,0,0-127.219,208.121Z",
    transform: "translate(127.825 -202.858)",
    fill: "#270504"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943",
    transform: "translate(144.777 58.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M-360.817,179.921a4.434,4.434,0,0,1,4.748-4.422,4.45,4.45,0,0,1,4.112,4.178,4.415,4.415,0,0,1-.7,2.654,9.957,9.957,0,0,0-1.359,3.068l-.123.506h-4.48l-.106-.437a10.42,10.42,0,0,0-1.389-3.157A4.41,4.41,0,0,1-360.817,179.921Z",
    transform: "translate(360.817 -175.488)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941",
    transform: "translate(1.585 10.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M-356.827,199.29h.109v-.349h-.109a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4.7a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-.109v.349h.109a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-4.7a.5.5,0,0,1-.5-.5A.5.5,0,0,1-356.827,199.29Z",
    transform: "translate(357.326 -197.943)",
    fill: "#324498"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942",
    transform: "translate(3.314 4.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M-352.914,191.066h.019a.227.227,0,0,0,.208-.245c-.068-.811-.129-1.613-.19-2.414-.052-.685-.1-1.37-.161-2.061a3.005,3.005,0,0,0,1.269-.007l-.491,4.474a.227.227,0,0,0,.2.251.228.228,0,0,0,.25-.2l.528-4.8a.229.229,0,0,0-.083-.2.227.227,0,0,0-.214-.039,2.5,2.5,0,0,1-1.629,0,.226.226,0,0,0-.219.028.227.227,0,0,0-.091.2c.067.8.128,1.6.188,2.392s.123,1.6.191,2.417A.227.227,0,0,0-352.914,191.066Z",
    transform: "translate(353.52 -185.803)",
    fill: "#270504"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947",
    transform: "translate(200.672 5.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M-433.185,109.368a4.434,4.434,0,0,1,4.748-4.422,4.45,4.45,0,0,1,4.112,4.178,4.415,4.415,0,0,1-.7,2.654,9.953,9.953,0,0,0-1.359,3.068l-.123.505h-4.48l-.106-.437a10.419,10.419,0,0,0-1.389-3.157A4.408,4.408,0,0,1-433.185,109.368Z",
    transform: "translate(433.185 -104.935)",
    fill: "#eee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945",
    transform: "translate(1.585 10.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M-429.2,128.736h.109v-.35h-.109a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4.7a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-.109v.35h.109a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-4.7a.5.5,0,0,1-.5-.5A.5.5,0,0,1-429.2,128.736Z",
    transform: "translate(429.694 -127.389)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946",
    transform: "translate(3.314 4.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M-425.281,120.512h.019a.227.227,0,0,0,.208-.245c-.068-.807-.129-1.6-.189-2.4-.053-.689-.1-1.378-.162-2.074a3.005,3.005,0,0,0,1.269-.007l-.491,4.473a.227.227,0,0,0,.2.251.228.228,0,0,0,.251-.2l.527-4.8a.228.228,0,0,0-.083-.2.23.23,0,0,0-.214-.039,2.5,2.5,0,0,1-1.629,0,.226.226,0,0,0-.219.029.228.228,0,0,0-.091.2c.068.808.129,1.606.189,2.4s.122,1.6.189,2.406A.227.227,0,0,0-425.281,120.512Z",
    transform: "translate(425.887 -115.249)",
    fill: "#270504"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_951",
    "data-name": "Group 951",
    transform: "translate(223.637 49.609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M-483.751,167.081A4.434,4.434,0,0,1-479,162.659a4.45,4.45,0,0,1,4.112,4.178,4.418,4.418,0,0,1-.7,2.654,9.952,9.952,0,0,0-1.359,3.068l-.123.506h-4.48l-.106-.437a10.41,10.41,0,0,0-1.389-3.157A4.411,4.411,0,0,1-483.751,167.081Z",
    transform: "translate(483.751 -162.648)",
    fill: "#d4d4d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949",
    transform: "translate(1.585 10.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M-479.762,186.45h.11V186.1h-.11a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4.7a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-.109v.349h.109a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-4.7a.5.5,0,0,1-.5-.5A.5.5,0,0,1-479.762,186.45Z",
    transform: "translate(480.261 -185.103)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_950",
    "data-name": "Group 950",
    transform: "translate(3.314 4.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M-475.848,178.226h.019a.226.226,0,0,0,.207-.245c-.067-.807-.128-1.6-.189-2.4-.053-.688-.105-1.377-.162-2.072a3.005,3.005,0,0,0,1.269-.007l-.491,4.473a.227.227,0,0,0,.2.25.226.226,0,0,0,.251-.2l.527-4.8a.227.227,0,0,0-.083-.2.229.229,0,0,0-.214-.04,2.5,2.5,0,0,1-1.63,0,.226.226,0,0,0-.219.028.228.228,0,0,0-.091.2c.068.807.128,1.605.189,2.4s.122,1.6.189,2.406A.227.227,0,0,0-475.848,178.226Z",
    transform: "translate(476.454 -172.963)",
    fill: "#270504"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_955",
    "data-name": "Group 955",
    transform: "translate(214.066 78.706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_952",
    "data-name": "Group 952",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M-462.677,207.976a4.434,4.434,0,0,1,4.748-4.422,4.45,4.45,0,0,1,4.112,4.178,4.416,4.416,0,0,1-.705,2.654,9.963,9.963,0,0,0-1.359,3.068l-.123.505h-4.48l-.106-.437a10.418,10.418,0,0,0-1.389-3.157A4.408,4.408,0,0,1-462.677,207.976Z",
    transform: "translate(462.677 -203.543)",
    fill: "#eee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_953",
    "data-name": "Group 953",
    transform: "translate(1.585 10.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M-458.688,227.344h.109v-.35h-.109a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4.7a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-.109v.35h.109a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-4.7a.5.5,0,0,1-.5-.5A.5.5,0,0,1-458.688,227.344Z",
    transform: "translate(459.187 -225.997)",
    fill: "#324498"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_954",
    "data-name": "Group 954",
    transform: "translate(3.314 4.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M-454.774,219.121h.019a.227.227,0,0,0,.208-.245c-.068-.807-.129-1.6-.189-2.4-.053-.688-.105-1.377-.162-2.072a3.005,3.005,0,0,0,1.269-.007l-.491,4.474a.227.227,0,0,0,.2.251.228.228,0,0,0,.25-.2l.527-4.8a.227.227,0,0,0-.083-.2.23.23,0,0,0-.214-.039,2.506,2.506,0,0,1-1.629,0,.226.226,0,0,0-.219.028.228.228,0,0,0-.091.2c.068.807.129,1.605.189,2.4s.122,1.6.19,2.406A.226.226,0,0,0-454.774,219.121Z",
    transform: "translate(455.38 -213.858)",
    fill: "#270504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968",
    transform: "translate(172.545 53.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_957",
    "data-name": "Group 957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M-433.361,168.954a12.075,12.075,0,0,1,12.93-12.044,12.118,12.118,0,0,1,11.2,11.377,12.022,12.022,0,0,1-1.92,7.227,27.127,27.127,0,0,0-3.7,8.354l-.333,1.377h-12.2l-.288-1.19a28.347,28.347,0,0,0-3.783-8.6A12.007,12.007,0,0,1-433.361,168.954Z",
    transform: "translate(433.361 -156.88)",
    fill: "rgba(138,215,255,0)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961",
    transform: "translate(7.415 5.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    "data-name": "Group 958",
    transform: "translate(0 1.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M-413.962,200.1a.363.363,0,0,0,.363-.356c.044-2.277.111-4.592.176-6.831.06-2.055.121-4.174.165-6.271a3.879,3.879,0,0,0,3.689-.6,3.865,3.865,0,0,0,1.238-4.049,3.865,3.865,0,0,0-3.293-2.661,7.167,7.167,0,0,0-1.322.047,7.018,7.018,0,0,1-1.119.052,3.4,3.4,0,0,1-3.048-2.788,3.4,3.4,0,0,1,2.075-3.571,3.4,3.4,0,0,1,3.932,1.266.362.362,0,0,0,.5.1.363.363,0,0,0,.1-.5,4.149,4.149,0,0,0-4.8-1.545,4.148,4.148,0,0,0-2.533,4.36,4.15,4.15,0,0,0,3.721,3.4,7.548,7.548,0,0,0,1.235-.054,6.529,6.529,0,0,1,1.189-.046,3.122,3.122,0,0,1,2.66,2.15,3.122,3.122,0,0,1-1,3.271,3.122,3.122,0,0,1-3.408.293.364.364,0,0,0-.358,0,.363.363,0,0,0-.182.308c-.045,2.272-.112,4.581-.176,6.814s-.133,4.557-.177,6.838a.363.363,0,0,0,.356.37Z",
    transform: "translate(417.872 -172.14)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959",
    transform: "translate(4.707 0.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M-408.318,180.769h.006a.363.363,0,0,0,.357-.369l-.168-10.142a.372.372,0,0,0-.369-.357.363.363,0,0,0-.357.369l.167,10.141A.363.363,0,0,0-408.318,180.769Z",
    transform: "translate(408.848 -169.901)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960",
    transform: "translate(3.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M-404.816,180.538a.363.363,0,0,0,.363-.357l.2-11.279a.363.363,0,0,0-.357-.37.366.366,0,0,0-.37.357l-.2,11.279a.363.363,0,0,0,.357.37Z",
    transform: "translate(405.18 -168.533)",
    fill: "#270504"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962",
    transform: "translate(12.704 1.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M-419.995,170.715h.012a.227.227,0,0,0,.215-.239,10.141,10.141,0,0,0-9.414-9.563.231.231,0,0,0-.242.211.227.227,0,0,0,.211.242,9.686,9.686,0,0,1,8.991,9.134A.227.227,0,0,0-419.995,170.715Z",
    transform: "translate(429.424 -160.913)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967",
    transform: "translate(4.317 27.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M-422.5,224.416a1.358,1.358,0,0,1-1.358-1.358A1.358,1.358,0,0,1-422.5,221.7h.3v-.952h-.3a1.358,1.358,0,0,1-1.358-1.358,1.358,1.358,0,0,1,1.358-1.358h12.8a1.358,1.358,0,0,1,1.358,1.358,1.358,1.358,0,0,1-1.358,1.358h-.3v.952h.3a1.358,1.358,0,0,1,1.358,1.358,1.358,1.358,0,0,1-1.358,1.358h-.3v.952h.3a1.358,1.358,0,0,1,1.358,1.358,1.358,1.358,0,0,1-1.358,1.358h-12.8a1.358,1.358,0,0,1-1.358-1.358,1.358,1.358,0,0,1,1.358-1.358h.3v-.952Z",
    transform: "translate(423.855 -218.032)",
    fill: "#3c5bbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965",
    transform: "translate(1.429 2.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M-421.138,223.966h12.5a.227.227,0,0,0,.227-.227.227.227,0,0,0-.227-.227h-12.5a.227.227,0,0,0-.227.227A.227.227,0,0,0-421.138,223.966Z",
    transform: "translate(421.365 -223.512)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966",
    transform: "translate(1.429 6.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M-420.481,232.043h12.2a.227.227,0,0,0,.227-.227.227.227,0,0,0-.227-.227h-12.2a.227.227,0,0,0-.227.227A.227.227,0,0,0-420.481,232.043Z",
    transform: "translate(420.708 -231.589)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977",
    transform: "translate(132.092 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M-387.366,55.607A16.855,16.855,0,0,1-369.317,38.8a16.915,16.915,0,0,1,15.633,15.881,16.786,16.786,0,0,1-2.68,10.087,37.861,37.861,0,0,0-5.167,11.662L-362,78.348h-17.031l-.4-1.661a39.571,39.571,0,0,0-5.281-12A16.759,16.759,0,0,1-387.366,55.607Z",
    transform: "translate(387.366 -38.754)",
    fill: "rgba(138,215,255,0)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_970",
    "data-name": "Group 970",
    transform: "translate(7.266 7.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M-362.888,89.476h1.733a.454.454,0,0,0,.452-.409l1.46-14.412A9.555,9.555,0,0,0-354.815,72a.453.453,0,0,0,.122-.351.453.453,0,0,0-.181-.325,1.682,1.682,0,0,1-.457-2.187,1.681,1.681,0,0,1,2.124-.7.453.453,0,0,0,.372-.005.456.456,0,0,0,.243-.282,9.6,9.6,0,0,0,.4-2.739,9.6,9.6,0,0,0-.4-2.739.456.456,0,0,0-.243-.282.453.453,0,0,0-.372-.006,1.682,1.682,0,0,1-2.124-.7,1.682,1.682,0,0,1,.457-2.187.453.453,0,0,0,.181-.325.453.453,0,0,0-.122-.351,9.554,9.554,0,0,0-4.743-2.74.455.455,0,0,0-.365.07.454.454,0,0,0-.191.319,1.682,1.682,0,0,1-1.665,1.491,1.682,1.682,0,0,1-1.665-1.491.454.454,0,0,0-.191-.319.456.456,0,0,0-.365-.07,9.55,9.55,0,0,0-4.743,2.74.453.453,0,0,0-.123.351.455.455,0,0,0,.181.325,1.682,1.682,0,0,1,.458,2.187,1.682,1.682,0,0,1-2.125.7.454.454,0,0,0-.372.006.453.453,0,0,0-.243.282,9.6,9.6,0,0,0-.4,2.739,9.6,9.6,0,0,0,.4,2.739.454.454,0,0,0,.243.282.456.456,0,0,0,.372.005,1.682,1.682,0,0,1,2.124.7,1.682,1.682,0,0,1-.457,2.187.456.456,0,0,0-.181.325.454.454,0,0,0,.123.351,9.55,9.55,0,0,0,4.417,2.656l.985,14.4A.455.455,0,0,0-362.888,89.476Zm1.323-.908h-.9l-.978-14.305a.454.454,0,0,0-.348-.411,8.634,8.634,0,0,1-3.968-2.154,2.589,2.589,0,0,0,.318-3.019,2.585,2.585,0,0,0-2.776-1.233,8.691,8.691,0,0,1-.242-2.035,8.694,8.694,0,0,1,.242-2.035,2.59,2.59,0,0,0,2.776-1.234,2.587,2.587,0,0,0-.318-3.018,8.64,8.64,0,0,1,3.523-2.037,2.588,2.588,0,0,0,2.456,1.787,2.588,2.588,0,0,0,2.456-1.787,8.636,8.636,0,0,1,3.523,2.037,2.588,2.588,0,0,0-.317,3.018,2.589,2.589,0,0,0,2.775,1.234,8.668,8.668,0,0,1,.242,2.035,8.677,8.677,0,0,1-.242,2.035,2.585,2.585,0,0,0-2.775,1.233A2.589,2.589,0,0,0-355.8,71.7a8.629,8.629,0,0,1-3.967,2.154.454.454,0,0,0-.347.4Zm-.214-19.088a4.074,4.074,0,0,0,4.069-4.069,4.074,4.074,0,0,0-4.069-4.07,4.074,4.074,0,0,0-4.069,4.07A4.074,4.074,0,0,0-361.779,69.479Zm0-7.23a3.165,3.165,0,0,1,3.161,3.161,3.164,3.164,0,0,1-3.161,3.161,3.164,3.164,0,0,1-3.161-3.161A3.165,3.165,0,0,1-361.779,62.249Z",
    transform: "translate(371.366 -56.072)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_971",
    "data-name": "Group 971",
    transform: "translate(17.881 2.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M-368.274,57.466h.012a.228.228,0,0,0,.215-.239A13.656,13.656,0,0,0-380.723,44.35a.231.231,0,0,0-.242.211.227.227,0,0,0,.211.243A13.2,13.2,0,0,1-368.5,57.251.227.227,0,0,0-368.274,57.466Z",
    transform: "translate(380.966 -44.35)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976",
    transform: "translate(6.026 38.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M-372.2,133.024a1.9,1.9,0,0,1-1.9-1.9,1.9,1.9,0,0,1,1.9-1.9h.416V127.9h-.416a1.9,1.9,0,0,1-1.9-1.9,1.9,1.9,0,0,1,1.9-1.9h17.864a1.9,1.9,0,0,1,1.9,1.9,1.9,1.9,0,0,1-1.9,1.9h-.416v1.329h.416a1.9,1.9,0,0,1,1.9,1.9,1.9,1.9,0,0,1-1.9,1.9h-.416v1.329h.416a1.9,1.9,0,0,1,1.9,1.9,1.9,1.9,0,0,1-1.9,1.9H-372.2a1.9,1.9,0,0,1-1.9-1.9,1.9,1.9,0,0,1,1.9-1.9h.416v-1.329Z",
    transform: "translate(374.098 -124.113)",
    fill: "#b08ff0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974",
    transform: "translate(1.992 3.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M-369.28,132.415h17.124a.227.227,0,0,0,.227-.227.227.227,0,0,0-.227-.227H-369.28a.227.227,0,0,0-.227.227A.227.227,0,0,0-369.28,132.415Z",
    transform: "translate(369.507 -131.961)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_975",
    "data-name": "Group 975",
    transform: "translate(1.992 8.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M-369.28,143.689h17.124a.227.227,0,0,0,.227-.227.227.227,0,0,0-.227-.227H-369.28a.227.227,0,0,0-.227.227A.227.227,0,0,0-369.28,143.689Z",
    transform: "translate(369.507 -143.235)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986",
    transform: "translate(64.686 12.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M-252.339,75.365a9.07,9.07,0,0,1,9.712-9.046,9.1,9.1,0,0,1,8.412,8.545,9.031,9.031,0,0,1-1.442,5.428,20.375,20.375,0,0,0-2.78,6.275l-.251,1.034h-9.165l-.216-.894a21.3,21.3,0,0,0-2.842-6.458A9.016,9.016,0,0,1-252.339,75.365Z",
    transform: "translate(252.339 -66.297)",
    fill: "rgba(138,215,255,0)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_979",
    "data-name": "Group 979",
    transform: "translate(4.116 5.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M-237.824,96.371a.363.363,0,0,0,.363-.363c0-1.64.024-3.263.045-4.887.02-1.53.04-3.059.044-4.6a5.869,5.869,0,0,0,2.124-.9,4.727,4.727,0,0,0,2.063-2.93,3.3,3.3,0,0,0-1.316-3.353A2.658,2.658,0,0,0-236.515,79a2.438,2.438,0,0,0-1.107.56,2.877,2.877,0,0,0-2.734-1.021,3.127,3.127,0,0,0-2.36,2.305,4.1,4.1,0,0,0,.616,3.219,6.057,6.057,0,0,0,2.488,2.057.363.363,0,0,0,.484-.173.363.363,0,0,0-.173-.484,5.34,5.34,0,0,1-2.193-1.8,3.362,3.362,0,0,1-.518-2.635,2.42,2.42,0,0,1,1.79-1.772,2.019,2.019,0,0,1,2.186,1.067.363.363,0,0,0,.3.244.358.358,0,0,0,.351-.169,1.594,1.594,0,0,1,1.028-.687,1.959,1.959,0,0,1,1.461.238,2.558,2.558,0,0,1,1,2.606,4,4,0,0,1-1.757,2.465,5.1,5.1,0,0,1-2.13.833.363.363,0,0,0-.312.359c0,1.645-.024,3.273-.045,4.9s-.043,3.252-.045,4.9a.363.363,0,0,0,.363.364Z",
    transform: "translate(242.824 -78.497)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_980",
    "data-name": "Group 980",
    transform: "translate(10.067 1.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M-242.255,76.972h.012a.227.227,0,0,0,.215-.239,6.424,6.424,0,0,0-5.964-6.058.231.231,0,0,0-.242.211.227.227,0,0,0,.211.242,5.969,5.969,0,0,1,5.541,5.629A.227.227,0,0,0-242.255,76.972Z",
    transform: "translate(248.235 -70.674)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_985",
    "data-name": "Group 985",
    transform: "translate(3.243 20.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M-244.179,117.023A1.02,1.02,0,0,1-245.2,116a1.02,1.02,0,0,1,1.02-1.02h.224v-.715h-.224a1.02,1.02,0,0,1-1.02-1.02,1.02,1.02,0,0,1,1.02-1.02h9.612a1.02,1.02,0,0,1,1.02,1.02,1.02,1.02,0,0,1-1.02,1.02h-.224v.715h.224a1.02,1.02,0,0,1,1.02,1.02,1.02,1.02,0,0,1-1.02,1.02h-.224v.715h.224a1.02,1.02,0,0,1,1.02,1.02,1.02,1.02,0,0,1-1.02,1.02h-9.612a1.02,1.02,0,0,1-1.02-1.02,1.02,1.02,0,0,1,1.02-1.02h.224v-.715Z",
    transform: "translate(245.199 -112.228)",
    fill: "#3c5bbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_983",
    "data-name": "Group 983",
    transform: "translate(1.017 1.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M-242.733,116.674h9.165a.227.227,0,0,0,.227-.227.227.227,0,0,0-.227-.227h-9.165a.227.227,0,0,0-.227.227A.227.227,0,0,0-242.733,116.674Z",
    transform: "translate(242.96 -116.22)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984",
    transform: "translate(1.017 4.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M-242.733,122.74h9.165a.227.227,0,0,0,.227-.227.227.227,0,0,0-.227-.227h-9.165a.227.227,0,0,0-.227.227A.227.227,0,0,0-242.733,122.74Z",
    transform: "translate(242.96 -122.286)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002",
    transform: "translate(44.125 51.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_987",
    "data-name": "Group 987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M-231.9,167.1a14.816,14.816,0,0,1,15.866-14.778,14.869,14.869,0,0,1,13.742,13.96,14.749,14.749,0,0,1-2.356,8.867,33.3,33.3,0,0,0-4.542,10.251l-.409,1.69h-14.971l-.354-1.46a34.766,34.766,0,0,0-4.642-10.55A14.732,14.732,0,0,1-231.9,167.1Z",
    transform: "translate(231.904 -152.288)",
    fill: "rgba(138,215,255,0)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995",
    transform: "translate(5.472 6.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_991",
    "data-name": "Group 991",
    transform: "translate(1.932 1.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_988",
    "data-name": "Group 988",
    transform: "translate(0 5.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M-193.16,203.633a.454.454,0,0,0,.454-.454V189.9a.453.453,0,0,0-.149-.336.457.457,0,0,0-.349-.116,6.1,6.1,0,0,1-4.911-1.761,6.1,6.1,0,0,1-1.761-4.911.454.454,0,0,0-.408-.5.452.452,0,0,0-.5.409,7,7,0,0,0,2.023,5.641,7.014,7.014,0,0,0,5.143,2.053v12.8A.454.454,0,0,0-193.16,203.633Z",
    transform: "translate(200.813 -182.275)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_989",
    "data-name": "Group 989",
    transform: "translate(0.588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M-207.364,173.964a.454.454,0,0,0,.414-.266,6.1,6.1,0,0,1,1.242-1.791,6.084,6.084,0,0,1,7.871-.651.454.454,0,0,0,.634-.1.454.454,0,0,0-.1-.634,6.989,6.989,0,0,0-9.042.747,6.985,6.985,0,0,0-1.426,2.057.454.454,0,0,0,.225.6A.452.452,0,0,0-207.364,173.964Z",
    transform: "translate(207.817 -169.201)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_990",
    "data-name": "Group 990",
    transform: "translate(9.281 2.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M-213.434,185.97a.453.453,0,0,0,.188-.041,7,7,0,0,0,2.057-1.426,6.99,6.99,0,0,0,.747-9.042.453.453,0,0,0-.634-.1.454.454,0,0,0-.1.634,6.085,6.085,0,0,1-.651,7.872,6.087,6.087,0,0,1-1.791,1.242.454.454,0,0,0-.225.6A.454.454,0,0,0-213.434,185.97Z",
    transform: "translate(213.888 -175.271)",
    fill: "#270504"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_992",
    "data-name": "Group 992",
    transform: "translate(11.213 10.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M-212.736,193.682h.033l3.538-.258a.455.455,0,0,0,.42-.486.455.455,0,0,0-.486-.42l-2.857.208.921-2.727a.454.454,0,0,0-.285-.575.453.453,0,0,0-.576.285l-1.139,3.375a.453.453,0,0,0,.071.423A.455.455,0,0,0-212.736,193.682Z",
    transform: "translate(213.191 -189.398)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_993",
    "data-name": "Group 993",
    transform: "translate(8.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M-207.364,170.228a.467.467,0,0,0,.106-.012l3.4-.81a.454.454,0,0,0,.315-.27.454.454,0,0,0-.035-.413l-1.773-2.833a.455.455,0,0,0-.626-.144.455.455,0,0,0-.144.626l1.438,2.3-2.782.664a.454.454,0,0,0-.336.547A.454.454,0,0,0-207.364,170.228Z",
    transform: "translate(207.818 -165.677)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_994",
    "data-name": "Group 994",
    transform: "translate(0 7.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M-185.042,185.846a.454.454,0,0,0,.257-.079.454.454,0,0,0,.117-.632l-1.977-2.878a.456.456,0,0,0-.365-.2.445.445,0,0,0-.372.182l-2.005,2.674a.454.454,0,0,0,.09.636.454.454,0,0,0,.636-.091l1.626-2.168,1.619,2.357A.454.454,0,0,0-185.042,185.846Z",
    transform: "translate(189.479 -182.059)",
    fill: "#270504"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996",
    transform: "translate(15.841 1.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M-215.935,168.644h.012a.227.227,0,0,0,.215-.239A12.434,12.434,0,0,0-227.25,156.68a.229.229,0,0,0-.243.211.227.227,0,0,0,.211.242,11.979,11.979,0,0,1,11.12,11.3A.227.227,0,0,0-215.935,168.644Z",
    transform: "translate(227.493 -156.679)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(5.297 34.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M-218.574,235.156a1.666,1.666,0,0,1-1.666-1.666,1.667,1.667,0,0,1,1.666-1.667h.366v-1.168h-.366a1.666,1.666,0,0,1-1.666-1.666,1.666,1.666,0,0,1,1.666-1.666h15.7a1.666,1.666,0,0,1,1.666,1.666,1.666,1.666,0,0,1-1.666,1.666h-.366v1.168h.366a1.666,1.666,0,0,1,1.666,1.667,1.666,1.666,0,0,1-1.666,1.666h-.366v1.168h.366a1.666,1.666,0,0,1,1.666,1.666,1.666,1.666,0,0,1-1.666,1.666h-15.7a1.666,1.666,0,0,1-1.666-1.666,1.666,1.666,0,0,1,1.666-1.666h.366v-1.168Z",
    transform: "translate(220.24 -227.322)",
    fill: "#270504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999",
    transform: "translate(1.805 3.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M-216.038,234.615h14.971a.227.227,0,0,0,.227-.227.227.227,0,0,0-.227-.227h-14.971a.227.227,0,0,0-.227.227A.227.227,0,0,0-216.038,234.615Z",
    transform: "translate(216.265 -234.161)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000",
    transform: "translate(1.805 7.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M-216.038,244.525h14.971a.227.227,0,0,0,.227-.227.227.227,0,0,0-.227-.227h-14.971a.227.227,0,0,0-.227.227A.227.227,0,0,0-216.038,244.525Z",
    transform: "translate(216.265 -244.071)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906",
    transform: "translate(179.949 1090.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890",
    transform: "translate(4.712 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    transform: "translate(73.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M290.336,193.671c-2.157,4.486-7.366,5.37-11.842,5.1-3.4-.207-6.436-.748-9.67.672-2.364,1.041-4.5,2.556-6.906,3.506a11.3,11.3,0,0,1-13.449-3.183c-1.6-1.778-2.935-3.92-5.1-5.087-2.278-1.233-5.052-1.308-7.573-1.511-5.118-.4-9.781-1.415-13.827-4.789a25.46,25.46,0,0,1-8.134-13.646c-2.577-10.513-.808-22.85,4.986-32.03,1.111-1.758,7.426-14.722,22.931-13.044,12.115,1.308,18.243,9.735,18,17.849-.076,2.435-1.051,5.608.5,7.78,1.485,2.081,4.426,1.607,6.674,1.7,5.517.232,8.735,3.557,9.927,8.8.722,3.147.844,6.239,3.036,8.8,1.859,2.167,4.33,3.718,6.386,5.684C289.79,183.632,292.685,188.8,290.336,193.671Z",
    transform: "translate(-212.684 -129.507)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M254.638,173.035l2.088,19.254-.006.006h3.245a40.959,40.959,0,0,1-4.176,7.185,13.4,13.4,0,0,1-22.19-.769,34.418,34.418,0,0,1-3.357-6.416h4.042l1.117-8.2-2.717-2.178a19.153,19.153,0,0,1-7.18-14.948v-12.1c8.9,2.184,23.037-5.535,23.037-5.535l2.986,10.94v.045l.017-.017a7.153,7.153,0,0,1,4.378-2.071,6.452,6.452,0,0,1,2.537.275c3.66,1.168,4.541,5.338,3.284,9.3C260.572,171.5,258.091,173.7,254.638,173.035Z",
    transform: "translate(-218.308 -138.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 2.091,
    cy: 1.891,
    rx: 2.091,
    ry: 1.891,
    transform: "translate(9.021 28.001) rotate(-87.561)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 2.091,
    cy: 1.891,
    rx: 2.091,
    ry: 1.891,
    transform: "translate(20.504 28.49) rotate(-87.561)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M231.912,167.008a4.48,4.48,0,0,0-4.252.6.58.58,0,0,0,.641.967,3.958,3.958,0,0,1,.37-.253c.063-.038.127-.073.192-.107l.022-.011.1-.045a3.782,3.782,0,0,1,.422-.152c.072-.021.145-.04.217-.058l.035-.008.121-.021a3.982,3.982,0,0,1,.447-.043c.075,0,.15,0,.225,0l.112,0h.013a4.217,4.217,0,0,1,.443.067c.074.016.146.034.218.053l.108.032.019.005.02.008a.6.6,0,0,0,.78-.256A.587.587,0,0,0,231.912,167.008Z",
    transform: "translate(-219.139 -145.833)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M249.733,168.491a.6.6,0,0,0,.755.321l.021-.006.019,0,.11-.022c.074-.014.147-.025.222-.035a4.256,4.256,0,0,1,.447-.029h.012l.112.006c.075,0,.149.012.223.021a3.917,3.917,0,0,1,.442.081l.119.031.034.011c.071.024.141.048.211.076a3.928,3.928,0,0,1,.408.187l.1.054.021.012q.093.059.182.123a3.93,3.93,0,0,1,.347.283.58.58,0,1,0,.721-.909,4.482,4.482,0,0,0-4.186-.956A.587.587,0,0,0,249.733,168.491Z",
    transform: "translate(-228.921 -146.205)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M283.069,169.951a1.356,1.356,0,0,0-.736-1.481,1.92,1.92,0,0,0-1.721.078,3.347,3.347,0,0,0-1.246,1.254,5.443,5.443,0,0,0-.735,3.576,2.043,2.043,0,0,1,2.422-.411,2.625,2.625,0,0,1,1.338,2.152,3.7,3.7,0,0,1-.815,2.46,6.391,6.391,0,0,1-2.042,1.657",
    transform: "translate(-241.589 -146.524)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 0.958
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M242.747,209.124a6.54,6.54,0,0,0,5.707,1.385c2.261-.544,4.034-2.244,5.69-3.877",
    transform: "translate(-225.871 -163.339)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 0.958
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M245.775,192.909a6.5,6.5,0,0,0,4.2-4.685",
    transform: "translate(-227.199 -155.264)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 0.958
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M237.377,173.984l-2.43,9.221,5.115-.137",
    transform: "translate(-222.45 -149.017)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 0.958
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_770",
    "data-name": "Rectangle 770",
    width: 59.778,
    height: 20.832,
    transform: "translate(64.017 146.513)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885",
    transform: "translate(0 32.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M236.5,292.063l-11.176,13.584H155.336V288.56a13.648,13.648,0,0,1-21.017-2.335L108.285,245.96l13.343-12.17,17.323,21.769,9.571-16.632A26.058,26.058,0,0,1,171.1,225.87h7.718a34.417,34.417,0,0,0,3.357,6.416,13.4,13.4,0,0,0,22.19.769,40.96,40.96,0,0,0,4.176-7.185h.814a26.057,26.057,0,0,1,24.811,18.1l7.219,22.515A27.2,27.2,0,0,1,236.5,292.063Z",
    transform: "translate(-93.102 -204.49)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M117.1,218.046l-9.847,8.981a19.117,19.117,0,0,1-8.185-4.574l1.122-20.512s-.139-4.009-.371-9.292a6.062,6.062,0,0,1,1.046-3.98,2.148,2.148,0,0,1,3.835.794l2.879,12.994Z",
    transform: "translate(-89.059 -187.783)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M99.96,212.578a2.964,2.964,0,0,1,2.836,4.693,2.526,2.526,0,0,1-.274.315,2.953,2.953,0,0,1,1.367,4.531,2.9,2.9,0,0,1-.528.553,2.951,2.951,0,0,1,1.3,4.5,3.059,3.059,0,0,1-.2.246,2.722,2.722,0,0,1,1.427,2,2.763,2.763,0,0,1-2.308,3.132l-5.591.853",
    transform: "translate(-88.583 -198.645)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 0.905
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M97.313,227.173a3.057,3.057,0,0,1-.2.246,2.722,2.722,0,0,1,1.427,2,2.763,2.763,0,0,1-2.308,3.132l-8.214,1.253a2.759,2.759,0,0,1-3.131-2.3,2.7,2.7,0,0,1,.4-1.88,2.947,2.947,0,0,1-1.087-5.153,2.964,2.964,0,0,1-1.3-4.515,3.075,3.075,0,0,1,.274-.315,2.966,2.966,0,0,1,.578-5.712l8.858-1.352a2.964,2.964,0,0,1,2.836,4.693,2.526,2.526,0,0,1-.274.315,2.953,2.953,0,0,1,1.367,4.531,2.9,2.9,0,0,1-.528.553,2.951,2.951,0,0,1,1.3,4.5Z",
    transform: "translate(-81.236 -198.645)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 11.676,
    y2: 1.781,
    transform: "translate(2.262 18.942)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 0.905
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x1: 11.156,
    y2: 1.702,
    transform: "translate(3.622 24.025)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 0.905
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x1: 11.226,
    y2: 1.712,
    transform: "translate(4.647 28.774)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 0.905
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 5.539,
    y2: 6.554,
    transform: "translate(45.85 51.069)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 0.905
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M196.033,265.138s-8.193,13.657-6.71,27.153",
    transform: "translate(-128.571 -221.715)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 0.905
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 5.93,
    y2: 24.343,
    transform: "translate(122.079 45.139)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 0.905
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886",
    transform: "translate(50.092 99.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M257.8,311.9l-1.01,46.125h-85.3L170.474,311.9a4.954,4.954,0,0,1,4.951-5.058h77.42A4.947,4.947,0,0,1,257.8,311.9Z",
    transform: "translate(-170.473 -306.84)",
    fill: "#dfdedc"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 79.584,
    transform: "translate(2.857 46.969)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x1: 0.929,
    y1: 44.304,
    transform: "translate(0.089 6.88)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y1: 44.304,
    x2: 1.012,
    transform: "translate(86.313 6.88)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889",
    transform: "translate(16.531 132.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_887",
    "data-name": "Group 887",
    transform: "translate(13.929 35.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M138.339,450.105a12.566,12.566,0,0,0,11.375,4.545L185,450.166l4-4.03L185.5,433.481h-4.937l-30.633-4.073a12.617,12.617,0,0,0-11.9,5.121l-.147.2A12.625,12.625,0,0,0,138.339,450.105Z",
    transform: "translate(-135.499 -429.297)",
    fill: "#b08ff0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M152.274,431a11.81,11.81,0,0,0-6.669,6.682,13.892,13.892,0,0,0-.135,9.518,16.9,16.9,0,0,0,5.636,7.753",
    transform: "translate(-139.534 -430.042)",
    fill: "none",
    stroke: "#dfdedc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M218.491,452.336a105.136,105.136,0,0,0-2.049-11.918",
    transform: "translate(-171.006 -434.175)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M200.252,441.641a22.673,22.673,0,0,1,1.053,11.336",
    transform: "translate(-163.904 -434.712)",
    fill: "none",
    stroke: "#dfdedc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M193.882,442.691a19.01,19.01,0,0,1,1.281,10.752",
    transform: "translate(-161.109 -435.172)",
    fill: "none",
    stroke: "#dfdedc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M187.456,443.316a17.75,17.75,0,0,1,1.952,10.449",
    transform: "translate(-158.29 -435.447)",
    fill: "none",
    stroke: "#dfdedc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M165.355,436.693a14.623,14.623,0,0,1,1.706,18.014",
    transform: "translate(-148.596 -432.541)",
    fill: "none",
    stroke: "#dfdedc",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M233.1,398.845l9.43,23.407L306.9,399.568a17.548,17.548,0,1,0-13.983-32.091Z",
    transform: "translate(-164.383 -365.463)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M196.211,406.544l-9.43,23.408-64.374-22.684a17.548,17.548,0,1,1,13.983-32.092Z",
    transform: "translate(-110.685 -368.841)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M256.24,434.036l-7.984,19.818,18.025,2.175,4.057-15.293Z",
    transform: "translate(-171.032 -395.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M197.04,398.02l37.051,19.428-8.3,20.607",
    transform: "translate(-148.565 -379.745)",
    fill: "none",
    stroke: "#dfdedc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x1: 24.345,
    y2: 12.954,
    transform: "translate(73.178 18.276)",
    fill: "none",
    stroke: "#dfdedc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888",
    transform: "translate(90.126 37.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M321.9,456.991a12.575,12.575,0,0,1-11.375,4.545l-35.282-4.484-4-4.03,3.492-12.655h4.937l30.633-4.074a12.618,12.618,0,0,1,11.9,5.121l.147.2A12.624,12.624,0,0,1,321.9,456.991Z",
    transform: "translate(-271.241 -434.355)",
    fill: "#b08ff0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M343.847,437.882a11.81,11.81,0,0,1,6.669,6.682,13.894,13.894,0,0,1,.135,9.519,16.9,16.9,0,0,1-5.636,7.753",
    transform: "translate(-303.09 -435.1)",
    fill: "none",
    stroke: "#dfdedc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M281.95,459.223A105.086,105.086,0,0,1,284,447.3",
    transform: "translate(-275.939 -439.233)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M289.9,446.547a27.5,27.5,0,0,1-3.888-4.763,9.24,9.24,0,0,1-1.415-5.878,3.954,3.954,0,0,1,1.013-2.291,2.165,2.165,0,0,1,2.337-.536,3.209,3.209,0,0,1,1.467,2.39c.815,3.673.526,7.49.232,11.241a10.786,10.786,0,0,0-5.576,7.893c-.133,1.021,0,2.253.9,2.765a2.311,2.311,0,0,0,2.606-.6,7.181,7.181,0,0,0,1.813-4.892,27.281,27.281,0,0,1,.41-5.318",
    transform: "translate(-276.85 -432.926)",
    fill: "none",
    stroke: "#dfdedc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M300.738,448.527a22.674,22.674,0,0,0-1.053,11.336",
    transform: "translate(-283.589 -439.77)",
    fill: "none",
    stroke: "#dfdedc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M306.945,449.578a19.007,19.007,0,0,0-1.281,10.752",
    transform: "translate(-286.22 -440.231)",
    fill: "none",
    stroke: "#dfdedc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M312.961,450.2a17.749,17.749,0,0,0-1.952,10.449",
    transform: "translate(-288.63 -440.505)",
    fill: "none",
    stroke: "#dfdedc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M333.533,443.579a14.624,14.624,0,0,0-1.706,18.014",
    transform: "translate(-296.795 -437.599)",
    fill: "none",
    stroke: "#dfdedc",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x2: 16.902,
    y2: 2.257,
    transform: "translate(93.754 190.762)",
    fill: "none",
    stroke: "#25292b",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905",
    transform: "translate(0 58.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891",
    transform: "translate(6 39.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M86.12,311.831h0a.248.248,0,0,1-.214-.124l-2.341-4.052a.248.248,0,0,1,0-.248l2.341-4.052a.248.248,0,0,1,.214-.124h0a.249.249,0,0,1,.215.124l2.346,4.052a.247.247,0,0,1,0,.249l-2.346,4.052A.249.249,0,0,1,86.12,311.831Zm-2.054-4.3,2.055,3.557,2.059-3.557-2.059-3.556Z",
    transform: "translate(-83.531 -303.231)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_892",
    "data-name": "Group 892",
    transform: "translate(0.666 40.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M75.442,307.694a1.413,1.413,0,1,1,1.413-1.413A1.416,1.416,0,0,1,75.442,307.694Zm0-2.331a.917.917,0,1,0,.917.917A.918.918,0,0,0,75.442,305.363Z",
    transform: "translate(-74.028 -304.867)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_893",
    "data-name": "Group 893",
    transform: "translate(5.013 35.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M83.008,298.711a1.235,1.235,0,1,1,1.235-1.235A1.236,1.236,0,0,1,83.008,298.711Zm0-1.973a.738.738,0,1,0,.739.738A.74.74,0,0,0,83.008,296.738Z",
    transform: "translate(-81.773 -296.242)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_894",
    "data-name": "Group 894",
    transform: "translate(0 36.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M73.756,300.225a.914.914,0,1,1,.914-.914A.915.915,0,0,1,73.756,300.225Zm0-1.333a.418.418,0,1,0,.418.418A.418.418,0,0,0,73.756,298.892Z",
    transform: "translate(-72.842 -298.396)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895",
    transform: "translate(45.935 4.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M156.712,248.291h0a.249.249,0,0,1-.215-.124l-1.791-3.1a.248.248,0,0,1,0-.248l1.791-3.1a.248.248,0,0,1,.215-.124h0a.246.246,0,0,1,.214.124l1.8,3.1a.246.246,0,0,1,0,.249l-1.8,3.1A.248.248,0,0,1,156.712,248.291Zm-1.5-3.349,1.5,2.605,1.508-2.605-1.508-2.6Z",
    transform: "translate(-154.673 -241.594)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_896",
    "data-name": "Group 896",
    transform: "translate(42.323 3.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M149.651,243.023a1.414,1.414,0,1,1,1.413-1.413A1.415,1.415,0,0,1,149.651,243.023Zm0-2.331a.918.918,0,1,0,.917.918A.918.918,0,0,0,149.651,240.692Z",
    transform: "translate(-148.238 -240.196)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897",
    transform: "translate(46.67 0.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M157.217,237.074a1.235,1.235,0,1,1,1.235-1.235A1.236,1.236,0,0,1,157.217,237.074Zm0-1.973a.738.738,0,1,0,.739.738A.74.74,0,0,0,157.217,235.1Z",
    transform: "translate(-155.982 -234.605)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898",
    transform: "translate(42.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M150.042,235.246a.914.914,0,1,1,.914-.914A.915.915,0,0,1,150.042,235.246Zm0-1.332a.418.418,0,1,0,.418.418A.418.418,0,0,0,150.042,233.914Z",
    transform: "translate(-149.128 -233.418)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_899",
    "data-name": "Group 899",
    transform: "translate(163.874 12.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M367.366,264.344h0a.249.249,0,0,1-.215-.124l-2.341-4.052a.248.248,0,0,1,0-.248l2.341-4.052a.248.248,0,0,1,.215-.124h0a.247.247,0,0,1,.214.124l2.346,4.052a.247.247,0,0,1,0,.249l-2.346,4.052A.249.249,0,0,1,367.366,264.344Zm-2.054-4.3,2.054,3.556,2.059-3.556-2.059-3.556Z",
    transform: "translate(-364.777 -255.744)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900",
    transform: "translate(174.773 15.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M385.606,264.238a1.413,1.413,0,1,1,1.413-1.413A1.414,1.414,0,0,1,385.606,264.238Zm0-2.331a.917.917,0,1,0,.917.918A.918.918,0,0,0,385.606,261.907Z",
    transform: "translate(-384.193 -261.411)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    "data-name": "Group 901",
    transform: "translate(163.015 8.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M364.482,251.224a1.235,1.235,0,1,1,1.235-1.235A1.236,1.236,0,0,1,364.482,251.224Zm0-1.973a.738.738,0,1,0,.739.738A.74.74,0,0,0,364.482,249.251Z",
    transform: "translate(-363.247 -248.755)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902",
    transform: "translate(170.377 13.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M377.275,260.019a.914.914,0,1,1,.914-.914A.915.915,0,0,1,377.275,260.019Zm0-1.331a.418.418,0,1,0,.418.418A.418.418,0,0,0,377.275,258.687Z",
    transform: "translate(-376.361 -258.191)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903",
    transform: "translate(169.854 5.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M377.147,248.789h0a.249.249,0,0,1-.215-.124l-1.47-2.545a.248.248,0,0,1,0-.248l1.47-2.545a.248.248,0,0,1,.215-.124h0a.248.248,0,0,1,.214.123l1.474,2.545a.25.25,0,0,1,0,.249l-1.474,2.544A.248.248,0,0,1,377.147,248.789ZM375.963,246l1.184,2.048L378.334,246l-1.187-2.049Z",
    transform: "translate(-375.429 -243.203)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904",
    transform: "translate(157.931 18.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M355.1,268.7a.914.914,0,1,1,.914-.914A.915.915,0,0,1,355.1,268.7Zm0-1.332a.418.418,0,1,0,.418.418A.418.418,0,0,0,355.1,267.367Z",
    transform: "translate(-354.19 -266.87)",
    fill: "#25292b"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVl1);
export default __webpack_public_path__ + "static/media/vl1.8a6bfc1d8fef766c0b412616a4ac62c8.svg";
export { ForwardRef as ReactComponent };